import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'
import MenuItem from './MenuItem'

function Menu({ className, items, type }) {
  return <Lib.Menu className={className} items={items} type={type} />
}

Menu.defaultProps = {
  className: '',
  type: 'static',
}

Menu.propTypes = {
  className: PropType.string,
  items: PropType.arrayOf(PropType.node).isRequired,
  type: PropType.oneOf(['static', 'popover', 'dynamic']),
}

Menu.Item = MenuItem
Menu.Divider = Lib.Divider

export default Menu
